import { applySnapshot, types } from 'mobx-state-tree';

const Theme = types
  .model({
    value: types.string,
  })
  .actions((self) => {
    const setTheme = (thm: 'light' | 'dark') => {
      self.value = thm;
      localStorage.quack_theme = thm;
    };
    const update = (themeData: any) => {
      applySnapshot(self, themeData);
    };
    return {
      setTheme,
      update,
    };
  });
export default Theme;
